import {FaInfoCircle, FaPlus} from "react-icons/fa";
import Button from "../../../../components/button/button";
import { Template } from "../../../../components/template/template";
import { Card } from "../../../../components/card/card";
import InputForm from "../../../../components/input/input-form";
import React, { useEffect, useState } from "react";
import { navigateHook } from "../../../../hooks/use-navigate";
import { useParams } from "react-router";
import { useMutation, useQuery } from "@tanstack/react-query";
import ReviewItemsService from "../../../../services/web/review-items-service";
import Swal from "sweetalert2";
import projectUtils from "../../../../utils/project-utils";
import Alert from "../../../../components/alert/alert.jsx";

export default function ReviewItemsForm() {
    const navigate = navigateHook();

    const { id } = useParams();
    const [state, setState] = useState({});

    const { data, isLoading, refetch } = useQuery({
        queryKey: ['review-items-data', id],
        enabled: !!id,
        queryFn: () => ReviewItemsService.getById(id)
    });

    useEffect(() => {
        if (data) setState(data);
    }, [data]);

    const onChange = ({ target: { value, id } })=> setState(prev => ({ ...prev, [id]: value}));

    const saveMutation = useMutation({
        mutationFn: async () => {
            const payload = {description: (state.description ?? "").trim()};
            return id ? ReviewItemsService.update(id, payload) : ReviewItemsService.create(payload);
        },
        onSuccess: (data) => {
            projectUtils.success(!id);

            if (!id) {
                const newId = data?.data?.id;

                const urlDev = `/review-items/form/${newId}`;
                navigate(urlDev);
                return;
            }
            refetch?.();
        },
        onError: (error) => {
            const {message} = error.response.data;
            let errMessage = message ?? "Não foi possível salvar.";

            if (errMessage === "name.already.used") errMessage = "Este \"Nome\" já está sendo utilizado."

            projectUtils.swalErrorMessage("", errMessage, "Ok");
        },
    });

    const handleSave = () => {
        if (!(state.description ?? "").trim()) {
            projectUtils.swalErrorMessage("", 'O campo "Nome" é obrigatório.', "Ok");
            return;
        }

        saveMutation.mutate();
    };

    const handleDelete = () => {
        if (!id) return;

        Swal.fire({
            title: "Excluir",
            text: `Excluir o item de revisão "${state.description}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#063A6C",
            confirmButtonText: "Sim",
            cancelButtonColor: "#c10007",
            cancelButtonText: "Não",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                return ReviewItemsService.delete(id).then(() => {
                    projectUtils.success(true ,"Excluído com sucesso");
                    navigateToList();
                })
                .catch((error) => {
                    console.error(error);
                    let message = 'Erro ao excluir.';
                    if (error.response.status !== 500) {
                        message = error.response.data.message;
                    }

                    projectUtils.swalErrorMessage('', message, 'Ok');
                })
            }
        })
    }

    const navigateToList = () => {
        const urlDev = "/review-items";
        navigate(urlDev);
    };

    const newReviewItem = () => {
        setState({ description: "" });
        const urlDev = "/review-items/form";
        navigate(urlDev);
    };

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Item de revisão</Template.Title>
                {id && (
                    <Button target="primary-outline" onClick={newReviewItem}><FaPlus />Adicionar item de revisão</Button>
                )}
            </Template.Header>
            <Template.Body className="space-y-2">
                <Card>
                    <Card.Body className="space-y-3">
                        <div className="flex gap-4">
                            <InputForm 
                                id="description"
                                label="Nome *"
                                value={state.description ?? ""}
                                onChange={onChange}
                                classNameWrapper="flex-1"
                                disabled={!!data?.isSystem}
                            />
                        </div>
                    </Card.Body>
                </Card>
                    <Card>
                        <Card.Body className="flex gap-2 justify-end items-center">
                            {
                                data?.isSystem &&
                                <Alert className={"flex gap-2 items-center"} target={"info"}>
                                    <FaInfoCircle /> Esse é um item de revisão padrão de sistema e não pode ser editado ou excluído
                                </Alert>
                            }

                            {
                                !data?.isSystem &&
                                <>
                                    {
                                        data?.cantDelete &&
                                        <Alert target="warning">Não é possível excluir, pois existem associações dependentes do item.</Alert>
                                    }
                                    {
                                        id &&
                                        <Button target="danger" onClick={handleDelete} disabled={data?.cantDelete} actionFeedbackType='delete'>Excluir</Button>
                                    }
                                    <Button onClick={handleSave} actionFeedbackType='save'>

                                        Salvar
                                    </Button>
                                </>
                            }
                        </Card.Body>
                    </Card>
            </Template.Body>
        </Template>
    )
}